import { PaginationInfo, ResponseMetadata } from './common'

export enum ReminderStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum ThresholdUnit {
  Days = 'days',
  Hours = 'hours',
  Weeks = 'weeks',
}

export interface ReminderConfiguration {
  name: string
  status: ReminderStatus
  unit: ThresholdUnit
  value: number
  is_default?: boolean
}

export interface WorkflowConfig {
  id: string
  company_id: string
  reminder_configurations: ReminderConfiguration[]
  template_name: string
  created_at: string
  created_by: string
  updated_at: string
  updated_by: string
}

export interface CompanyWithWorkflowConfig {
  id?: string
  company_id: string
  company_name: string
  workflow_definition_id: string | null
  has_workflow: boolean
  has_reminder: boolean
  reminder_configurations: ReminderConfiguration[]
  created_at: string | null
  created_by: string | null
  updated_at: string | null
  updated_by: string | null
  workflow_config: WorkflowConfig | null
}

export interface RequestCreateWorkflowConfig {
  company_id: string
  reminder_configurations: ReminderConfiguration[]
  template_name: string
}

export interface RequestUpdateWorkflowConfig {
  reminder_configurations?: ReminderConfiguration[]
  template_name?: string
}

export interface SuccessResponseListCompaniesWithWorkflowConfig {
  success: boolean
  data: CompanyWithWorkflowConfig[]
  metadata: ResponseMetadata
  pagination: PaginationInfo
  links: null
  warnings: string[] | null
}

export interface SuccessResponseGetWorkflowConfig {
  success: boolean
  data: WorkflowConfig
  metadata: ResponseMetadata
  pagination: null
  links: null
  warnings: string[] | null
}

export interface SuccessResponseCreateWorkflowConfig {
  success: boolean
  data: WorkflowConfig
  metadata: ResponseMetadata
  pagination: null
  links: null
  warnings: string[] | null
}

export interface SuccessResponseUpdateWorkflowConfig {
  success: boolean
  data: WorkflowConfig
  metadata: ResponseMetadata
  pagination: null
  links: null
  warnings: string[] | null
}

export interface SuccessResponseDeleteWorkflowConfig {
  success: boolean
  data: null
  metadata: ResponseMetadata
  pagination: null
  links: null
  warnings: string[] | null
}

export interface ErrorResponseWorkflowConfig {
  success: false
  error: {
    code: string
    message: string
    details?: {
      field?: string
      reason?: string
    }[]
  }
  metadata: ResponseMetadata
}
